import { useState } from "react";
import { useLocation } from "react-router";
import { Select } from "antd";
import GeneralPolicy from "./GeneralPolicy";
import InformationSecurityPolicy from "./InformationSecurityPolicy";
import ComplaintResponsePolicy from "./ComplaintResponsePolicy";
import PaymentPolicy from "./PaymentPolicy";
import ExchangeRefundPolicy from "./ExchangeRefundPolicy";
// import OnlinePurchasingPolicy from "./OnlinePurchasingPolicy";
import { useTranslation } from "react-i18next";

const PolicyPage = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const [selectedPolicy, setSelectedPolicy] = useState<string>(
    location.state?.policy || "1"
  );

  const policies = [
    {
      value: "1",
      label: t("footer.policy.general")
    },
    {
      value: "2",
      label: t("footer.policy.information_security")
    },
    {
      value: "3",
      label: t("footer.policy.complaint")
    },
    {
      value: "4",
      label: t("footer.policy.payment")
    },
    {
      value: "5",
      label: t("footer.policy.exchange_refund")
    }
    // {
    //   value: "6",
    //   label: t("footer.policy.online_purchasing")
    // }
  ];

  const renderPolicy = () => {
    switch (selectedPolicy) {
      case "1":
        return <GeneralPolicy />;
      case "2":
        return <InformationSecurityPolicy />;
      case "3":
        return <ComplaintResponsePolicy />;
      case "4":
        return <PaymentPolicy />;
      // return <GeneralPolicy />;
      case "5":
        return <ExchangeRefundPolicy />;
      // case "6":
      //   return <OnlinePurchasingPolicy />;
      default:
        return <p className="font-bold text-3xl">Policy not found</p>;
    }
  };

  return (
    <div className="w-full flex justify-center items-center px-6 py-20">
      <div className="w-full max-w-standard flex flex-col gap-20">
        {/* Policy Select */}
        <div className="w-full flex justify-end items-center">
          <Select
            size="large"
            showSearch
            placeholder="Select policy"
            filterOption={(input, option) =>
              (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
            }
            options={policies}
            value={selectedPolicy}
            onChange={(e) => setSelectedPolicy(e)}
            className="w-[40%]"
          />
        </div>

        {/* Policy Content */}
        <div className="w-full">{renderPolicy()}</div>
      </div>
    </div>
  );
};

export default PolicyPage;
